module.exports = __webpack_public_path__ + "static/media/Payal.26edc122.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/team/Payal.webp
// module id = 292
// module chunks = 0